import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase'; // Import your Firebase db instance
import Navbar from '../components/home/Navbar';

const ViewEtatFinan = () => {
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    const fetchYears = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'etat_finance'));
        const yearsSet = new Set();
        querySnapshot.forEach((doc) => {
          yearsSet.add(doc.data().annee);
        });
        const sortedYears = Array.from(yearsSet).sort((a, b) => b - a);
        setYears(sortedYears);

        if (sortedYears.length > 0) {
          const defaultYear = sortedYears[0];
          setSelectedYear(defaultYear);
          await fetchYearData(defaultYear);
        }
      } catch (error) {
        console.error("Error fetching years: ", error);
      }
    };

    fetchYears();
  }, []);

  const fetchYearData = async (year) => {
    try {
      const querySnapshot = await getDocs(collection(db, 'etat_finance'));
      const yearData = querySnapshot.docs
        .filter(doc => doc.data().annee === year)
        .map(doc => doc.data())[0];

      if (!yearData) {
        throw new Error('No data found for the selected year');
      }

      setPdfUrl(yearData.lien);
    } catch (error) {
      console.error("Error fetching details: ", error);
    }
  };

  const handleYearClick = async (year) => {
    setSelectedYear(year);
    await fetchYearData(year);
  };

  return (
    <div>
      <Navbar />
      <div style={{ display: 'flex' }}>
        <div style={{
          width: '200px',
          borderRight: '1px solid #ddd',
          padding: '20px',
          backgroundColor: '#f9f9f9',
          height: '100vh',
          boxShadow: '2px 0 5px rgba(0,0,0,0.1)',
          borderRadius: '8px'
        }}>
          <h3 style={{
            fontFamily: 'Arial, sans-serif',
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#00674b',
            margin: '0 0 20px 0'
          }}>
            Années
          </h3>
          <ul style={{
            listStyleType: 'none',
            padding: 0,
            margin: 0
          }}>
            {years.map(year => (
              <li key={year}
                  onClick={() => handleYearClick(year)}
                  style={{
                    cursor: 'pointer',
                    padding: '10px',
                    borderRadius: '4px',
                    transition: 'background-color 0.3s ease',
                    marginBottom: '5px',
                    backgroundColor: '#ffffff',
                    color: '#0d47a1',
                    border: '1px solid #bbdefb'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#bbdefb'}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
              >
                {year}
              </li>
            ))}
          </ul>
        </div>
        <div style={{ flex: 1, padding: '10px' }}>
          <div style={{
            backgroundColor: '#00674b',
            color: '#ffffff',
            padding: '20px',
            borderRadius: '10px',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            <h2 style={{
              fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
              fontSize: '32px',
              fontWeight: 'bold',
              margin: 0
            }}>
              Les états financiers pour l'année {selectedYear || ''}
            </h2>
          </div>

          {pdfUrl ? (
    

             <center>
               <iframe
                 src={pdfUrl}
                 width="80%"
                 height="1200vh"
                 frameBorder="0"
                 title="PDF Viewer"
               >
                 This browser does not support PDFs. Please download the PDF to view it: <a href={pdfUrl}>Download PDF</a>.
               </iframe>
             </center>
        
          ) : (
            <p>Loading...</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewEtatFinan;
